// extracted by mini-css-extract-plugin
export var svgPolygonFill = "cd_j6";
export var svgPolygonFillNone = "cd_j8";
export var svgPolygonStroke = "cd_j7";
export var svgPolygonStrokeThree = "cd_kb";
export var svgPolygonStrokeTwoFive = "cd_j9";